import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components';

// import copycat_x24 from '../../static/copycat_x24.svg';
// import producthunt_logo from '../../static/producthunt_logo.svg';
// import verge_logo from '../../static/verge_logo.svg';
// import reddit_logo from '../../static/reddit.svg';
// import designernews_logo from '../../static/designernews_logo.svg';
import {navData} from '../../utils/navData';
import Logo from '../logo';
import NavLink from './navLink';


const SidebarWrapper = styled.nav`
  height: 100vh;
  display: flex;
  position: fixed;
  width: 300px;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 34px rgba(0, 0, 0, 0.08);
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  width: 100%;
  background: #141419;
  height: 200px;
`;

const LinksWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    .navDesc {
      margin: 8px 0;
      padding: 8px 40px;
      color: #141419;
      opacity: 0.4;
      font-weight: 200;
    }

    .source__logo {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 16px;
    }
`;

const InfoWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 8px 40px;
    margin-bottom: 128px;
    width: 100%;

    .info-text {
      font-size: 12px;
    }
`

const DeskNav = ({ siteTitle }) => {

  const link__itemActive = {
    background: '#fbfbfb',
    color: '#141419',
    boxShadow: '0 6px 24px rgba(0, 0, 0, 0.14)',
    width: '85%',
    borderRadius: '0 50px 50px 0',
    fontWeight: '700',
    transition: 'all .2s ease'
  }

  const link__item = {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    margin: '8px 0',
    padding: '8px 40px',
    width: '85%',
    borderRadius: '0 50px 50px 0',
    color: '#888',
    fontSize: '14px',
    transition: 'all .2s ease'
  }

  return (
    <SidebarWrapper>
      <LogoWrapper>
        <Logo />
      </LogoWrapper>
      <LinksWrapper>
        <NavLink title={navData[0].title} image={navData[0].image} href={navData[0].href} />
        <p className="navDesc">Categories</p>
        {navData.map((obj, i) => (
          i !== 0 && <NavLink key={i} title={obj.title} image={obj.image} href={obj.href} />
        ))}
    </LinksWrapper>
    <InfoWrapper>
      <p className="info-text">This newsreader was created during Daresay Summer Camp 2018.<br /><br /> For feedback, questions, and new ideas please contact mikael.skoglund@daresay.co</p>
    </InfoWrapper>
  </SidebarWrapper>
 )
}

export default DeskNav



// WEBPACK FOOTER //
// ./src/components/deskNav/index.js